'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('./Answer.css');

var _RenderHelper = require('../RenderHelper');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
  return _react2.default.createElement(
    'div',
    { onClick: props.onClick,
      className: 'wsequiz_answer ' + (props.selected ? 'wsequiz_answer_selected' : '') + ' ' + (props.isPicture ? 'wsequiz_answer_image' : '') },
    props.isPicture && props.data.get('image') && (0, _RenderHelper.mountImage)(props.data.get('image'), props.imgParams),
    _react2.default.createElement(
      'div',
      { className: 'wsequiz_answer_text' },
      props.data.get('text')
    )
  );
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/wse-quiz-component/lib/blocks/Answer.js
// module id = 800
// module chunks = 0